import React from "react"
import RegistrationPage from "./RegistrationPage/RegistrationPage"

export default () => <RegistrationPage />
